import "../../css/admindash.css"
import bubble from "../../media/whiteFav.png"
import ApexCharts from "apexcharts"
import heartRobot from "../../media/heartRobot.png"
import { useEffect, useRef, useState } from "react"
import usefbStore from "../../store/firebasestore"
import useStore from "../../store/zustandstore"
import Swal from "sweetalert2"
import axios from "axios"
import { getDocs,updateDoc,collection } from "firebase/firestore"
import { db } from "../../firebase/firebase"

function AdminDashDrawer() {
  const adminGraph = useRef(null)
  const adminName = usefbStore((s) => s.adminName)
  const withdrawRequests = usefbStore((s) => s.withdrawRequests) 
  const emailList = usefbStore((s)=>s.emailList)



  // Format date function
  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A"
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp)
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    })
  }
// Show withdrawal details popup
const showWithdrawalDetails = (request) => {
  const method = request.withdrawMethod?.trim();
  const isBank = method === "Bank Transfer";
  const isCrypto = method === "Crypto Currency";
  const isPaypal = method === "PayPal";

  const bankDetails = request.bankDetails || {};
  const cryptoDetails = request.cryptoDetails || {};
  const paypalDetails = request.paypalDetails || {};

  let detailsHtml = `
    <div style="text-align: left; font-family: inherit;">

      <div style="
        background: #f8f9ff;
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 15px;
      ">
        <p><strong>Amount:</strong> $${request.amount}</p>
        <p><strong>Requested:</strong> ${formatDate(request.createdAt)}</p>
        <p><strong>Method:</strong> ${request.withdrawMethod}</p>
        <p><strong>Requester:</strong> ${request.name}</p>
        <p><strong>Email:</strong> ${request.email}</p>
        <p><strong>User ID:</strong> ${request.uid}</p>

        <p>
          <strong>Status:</strong>
          <span style="
            color: ${
              request.status === "pending"
                ? "#f39c12"
                : request.status === "completed"
                ? "#27ae60"
                : "#e74c3c"
            };
          ">
            ${request.status?.toUpperCase()}
          </span>
        </p>
      </div>
  `;

  // ==========================================
  // BANK TRANSFER
  // ==========================================
  if (isBank) {

    detailsHtml += `
      <div style="
        background: #f8f9ff;
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 15px;
      ">
        <h4 style="margin-bottom: 10px;">🏦 Bank Details</h4>

        <p>
          <strong>Bank:</strong>
          ${bankDetails.bankName || "N/A"}
        </p>

        <p>
          <strong>Account Name:</strong>
          ${bankDetails.accountName || "N/A"}
        </p>

        <p>
          <strong>Account Number:</strong>
          ${bankDetails.accountNumber || "N/A"}
        </p>
      </div>
    `;

  // ==========================================
  // PAYPAL
  // ==========================================
  } else if (isPaypal) {

    detailsHtml += `
      <div style="
        background: #f8f9ff;
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 15px;
      ">
        <h4 style="margin-bottom: 10px;">💳 PayPal Details</h4>

        <p>
          <strong>Account Name:</strong>
          ${paypalDetails.accountName || "N/A"}
        </p>

        <p>
          <strong>PayPal Email:</strong>
          ${paypalDetails.email || "N/A"}
        </p>
      </div>
    `;

  // ==========================================
  // CRYPTO
  // ==========================================
  } else if (isCrypto) {

    detailsHtml += `
      <div style="
        background: #f8f9ff;
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 15px;
      ">
        <h4 style="margin-bottom: 10px;">🪙 Crypto Details</h4>

        <p>
          <strong>Wallet Address:</strong>
          ${cryptoDetails.walletAddress || "N/A"}
        </p>

        <p>
          <strong>Network:</strong>
          ${cryptoDetails.network || "Ethereum (ERC-20)"}
        </p>
      </div>
    `;
  }

  detailsHtml += `</div>`;

  Swal.fire({
    title: "Withdrawal Request Details",
    html: detailsHtml,
    icon: "info",
    width: "500px",
    showCancelButton: true,
    confirmButtonText: "Complete Transaction",
    cancelButtonText: "Close",
    confirmButtonColor: "#27ae60",
    cancelButtonColor: "#d33",
    reverseButtons: true,
    showDenyButton: true,
    denyButtonText: "Reject",
    denyButtonColor: "#e74c3c"
  }).then((result) => {

    if (result.isConfirmed) {
      completeTransaction(request);
    } else if (result.isDenied) {
      rejectTransaction(request);
    }

  });
};
// Complete transaction function
const completeTransaction = async (request) => {
  const isCrypto = request.withdrawMethod === "Crypto Currency";
  const isBank = request.withdrawMethod === "Bank Transfer";
  const isPaypal = request.withdrawMethod === "PayPal";

  // Confirmation message based on withdrawal type
  const confirmationMessage = isCrypto
    ? `Are you sure you want to process $${request.amount} CRYPTO withdrawal for ${request.name}?\n\n⚠️ This will deduct from balance. Send crypto manually via Minisend.`
    : isPaypal
    ? `Are you sure you want to process $${request.amount} PayPal withdrawal for ${request.name}?\n\nPayPal: ${request.paypalDetails?.email || "No PayPal email found"}\n\n⚠️ This will deduct from balance. Send the payment manually via PayPal.`
    : `Are you sure you want to process $${request.amount} BANK withdrawal for ${request.name}?`;

  Swal.fire({
    title: "Complete Withdrawal",
    text: confirmationMessage,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Process",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#27ae60"
  }).then(async (result) => {
    if (!result.isConfirmed) return;

    Swal.fire({
      title: "Processing",
      text: "Processing withdrawal request...",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    try {
      // ==========================================
      // CRYPTO
      // ==========================================
      let requestConfig;

      if (isCrypto) {
        requestConfig = {
          endpoint:
            "https://solaraback-g1bm.onrender.com/process-crypto-withdrawal",

          body: {
            withdrawalId: request.id,
            amount: parseFloat(request.amount),

            cryptoDetails: {
              walletAddress: request.cryptoDetails?.walletAddress,
              network:
                request.cryptoDetails?.network || "Ethereum (ERC-20)",
              currency:
                request.cryptoDetails?.currency || "USDT"
            },

            withdrawMethod: request.withdrawMethod,
            uid: request.uid,
            name: request.name,
            email: request.email,
            adminName: adminName
          }
        };

      // ==========================================
      // PAYPAL
      // ==========================================
      } else if (isPaypal) {
        requestConfig = {
           endpoint:
             "https://solaraback-g1bm.onrender.com/process-paypal-withdrawal",

          body: {
            withdrawalId: request.id,
            amount: parseFloat(request.amount),

            paypalDetails: {
              accountName:
                request.paypalDetails?.accountName,
              email:
                request.paypalDetails?.email
            },

            withdrawMethod: request.withdrawMethod,
            uid: request.uid,
            name: request.name,
            email: request.email,
            adminName: adminName
          }
        };

      // ==========================================
      // BANK
      // ==========================================
      } else if (isBank) {
        requestConfig = {
          endpoint:
            "https://solaraback-g1bm.onrender.com/process-withdrawal",

          body: {
            withdrawalId: request.id,
            amount: Math.round(parseFloat(request.amount)),
            amountInKES: request.amount,

            bankDetails: {
              accountNumber:
                request.bankDetails?.accountNumber,
              bankCode:
                request.bankDetails?.bankCode,
              accountName:
                request.bankDetails?.accountName,
              bankName:
                request.bankDetails?.bankName
            },

            withdrawMethod: request.withdrawMethod,
            uid: request.uid,
            name: request.name,
            email: request.email,
            adminName: adminName
          }
        };

      } else {
        throw new Error("Unsupported withdrawal method.");
      }

      // ==========================================
      // SEND REQUEST
      // ==========================================

      const response = await fetch(requestConfig.endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestConfig.body)
      });

      const result = await response.json();

      // ==========================================
      // SUCCESS
      // ==========================================
      if (result.success) {
        let successText =
          `Withdrawal of $${request.amount} processed successfully!`;

        if (isCrypto) {
          successText =
            `✅ Crypto withdrawal processed!\n\n` +
            `Amount: $${request.amount}\n` +
            `Wallet: ${request.cryptoDetails?.walletAddress}\n\n` +
            `📌 Remember to send crypto via Minisend.`;
        }

        if (isPaypal) {
          successText =
            `✅ PayPal withdrawal processed!\n\n` +
            `Amount: $${request.amount}\n` +
            `PayPal: ${request.paypalDetails?.email}\n\n` +
            `💳 Send the payment manually via PayPal.`;
        }

        if (isBank) {
          successText =
            `✅ Bank withdrawal processed successfully!\n\n` +
            `Amount: $${request.amount}\n` +
            `Account: ${request.bankDetails?.accountName}`;
        }

        Swal.fire({
          title: "Success!",
          text: successText,
          icon: "success",
          confirmButtonColor: "#27ae60"
        }).then(() => window.location.reload());

      } else {
        throw new Error(
          result.message || "Processing failed"
        );
      }

    } catch (error) {
      console.error("Error:", error);

      Swal.fire({
        title: "Error",
        text:
          error.message ||
          "Failed to process withdrawal",
        icon: "error",
        confirmButtonColor: "#d33"
      });
    }
  });
};
// Reject transaction function
const rejectTransaction = async (request) => {
  const isCrypto = request.withdrawMethod === "Crypto Currency";  
  Swal.fire({
    title: "Reject Withdrawal",
    text: `Are you sure you want to reject $${request.amount} ${isCrypto ? 'CRYPTO ' : ''}withdrawal for ${request.name}?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Reject",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#e74c3c"
  }).then(async (result) => {
    if (result.isConfirmed) {
      Swal.fire({
        title: "Processing",
        text: "Rejecting withdrawal request...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading()
      });
      
      try {
        // Use same endpoint for both (it handles both types)
        const response = await fetch('https://solaraback-g1bm.onrender.com/reject-withdrawal', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            withdrawalId: request.id,
            adminName: adminName,
            reason: `Rejected by admin - ${isCrypto ? 'Crypto' : 'Bank'} withdrawal`,
            uid: request.uid,
            name:request.name,
            email:request.email,
            amount: request.amount,
            withdrawMethod: request.withdrawMethod,
            bankDetails: request.bankDetails,
            cryptoDetails: request.cryptoDetails
          })
        });
        
        const result = await response.json();
        
        if (result.success) {
          Swal.fire({
            title: "Transaction Rejected!",
            text: `$${request.amount} ${isCrypto ? 'crypto ' : ''}withdrawal has been rejected.`,
            icon: "warning",
            confirmButtonColor: "#e74c3c"
          }).then(() => window.location.reload());
        } else {
          throw new Error(result.message || "Rejection failed");
        }
      } catch (error) {
        console.error("Error rejecting transaction:", error);
        Swal.fire({
          title: "Error",
          text: error.message || "Failed to reject transaction",
          icon: "error",
          confirmButtonColor: "#d33"
        });
      }
    }
  });
};
// OTP Modal function (if required by Paystack)
const showOtpModal = (request, transferCode) => {
  Swal.fire({
    title: "OTP Required",
    html: `
      <div style="text-align: left;">
        <p>An OTP has been sent to your registered phone number.</p>
        <input type="text" id="otpInput" class="swal2-input" placeholder="Enter OTP" style="width: 100%; margin-top: 10px;">
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "Verify OTP",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#27ae60",
    didOpen: () => {
      const input = document.getElementById('otpInput');
      input.focus();
    },
    preConfirm: async () => {
      const otp = document.getElementById('otpInput').value;
      
      if (!otp || otp.length !== 6) {
        Swal.showValidationMessage('Please enter a valid 6-digit OTP');
        return false;
      }
      
      try {
        const response = await fetch('https://solaraback-g1bm.onrender.com/finalize-transfer', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            transferCode: transferCode,
            otp: otp,
            withdrawalId: request.id
          })
        });
        
        const result = await response.json();
        
        if (result.success) {
          Swal.fire({
            title: "Success!",
            text: "Transfer completed successfully!",
            icon: "success"
          });
          setTimeout(() => window.location.reload(), 2000);
        } else {
          Swal.showValidationMessage(result.message || 'Invalid OTP');
        }
      } catch (error) {
        Swal.showValidationMessage('Failed to verify OTP');
      }
    }
  });
}
  // Chart initialization
  useEffect(() => {
    var options = {
      series: [{
        name: 'Content Review',
        data: [31, 40, 28, 51, 42, 109, 100]
      }, {
        name: 'Fact Check',
        data: [11, 32, 45, 32, 34, 52, 41]
      }, {
        name: 'Translation',
        data: [76, 45, 3, 32, 134, 13, 96]
      }],
      colors: ["#5EA7FA", "#2332DF", "#dfad23"],
      chart: {
        height: "100%",
        type: 'area'
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "smooth",
        width: 1,
      },
      grid: {
        show: false,
      },
      legend: {
        show: false,
      },
      xaxis: {
        type: 'datetime',
        categories: ["01 Jan", "02 Jan", "03 Jan", "04 Jan", "05 Jan", "06 Jan", "07 Jan"]
      },
      tooltip: {
        x: {
          format: 'dd/MM/yy HH:mm'
        },
      },
    }
    
    if (adminGraph.current) {
      var chart = new ApexCharts(adminGraph.current, options)
      chart.render()
    }
  }, [])

  // Separate pending and completed requests
  const pendingRequests = withdrawRequests.filter(req => req.status === "pending")
  const completedRequests = withdrawRequests.filter(req => req.status === "completed")
  const rejectedRequests = withdrawRequests.filter(req => req.status === "rejected")


  return (
    <div className="adminDashDrawerPulled">
   

      <div className="admin-dashRight">
        <div className="adminGraph">
          <div className="adminGraphCont" ref={adminGraph}></div>
        </div>

        <div className="adminApplicants">
          <div className="applicantsHeader">
            <h4>Withdrawal Requests</h4>
            <div className="requestStats">
              <span className="pendingCount">Pending: {pendingRequests.length}</span>
              <span className="completedCount">Completed: {completedRequests.length}</span>
            </div>
          </div>

          <div className="applicantsList">
            {pendingRequests.length === 0 && completedRequests.length === 0 ? (
              <div className="noRequests">
                <p>No withdrawal requests found.</p>
              </div>
            ) : (
              <>
                {/* Pending Requests */}
                {pendingRequests.length > 0 && (
                  <>
                    <div className="sectionTitle">
                      <p>Pending</p>
                    </div>
                    {pendingRequests.map((request) => (
                      <div 
                        className="adminApplicant pending" 
                        key={request.id}
                        onClick={() => showWithdrawalDetails(request)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="apName">
                          <p>{request.name || request.uid?.slice(0, 8)}</p>
                          <span className="method">{request.withdrawMethod}</span>
                        </div>
                        <div className="apProf">
                          <p>${request.amount}</p>
                        </div>
                        <div className="apDate">
                          <span className="status-badge pending">Pending</span>
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {/* Completed Requests */}
                {completedRequests.length > 0 && (
                  <>
                    <div className="sectionTitle">
                      <p>Completed</p>
                    </div>
                    {completedRequests.map((request) => (
                      <div 
                        className="adminApplicant completed" 
                        key={request.id}
                        onClick={() => showWithdrawalDetails(request)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="apName">
                          <p>{request.name || request.uid?.slice(0, 8)}</p>
                          <span className="method">{request.withdrawMethod}</span>
                        </div>
                        <div className="apProf">
                          <p>${request.amount}</p>
                        </div>
                        <div className="apDate">
                          <span className="status-badge completed">Completed</span>
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {/* Rejected Requests */}
                {rejectedRequests.length > 0 && (
                  <>
                    <div className="sectionTitle">
                      <p>Rejected</p>
                    </div>
                    {rejectedRequests.map((request) => (
                      <div 
                        className="adminApplicant rejected" 
                        key={request.id}
                        onClick={() => showWithdrawalDetails(request)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="apName">
                          <p>{request.name || request.uid?.slice(0, 8)}</p>
                          <span className="method">{request.withdrawMethod}</span>
                        </div>
                        <div className="apProf">
                          <p>${request.amount}</p>
                        </div>
                        <div className="apDate">
                          <span className="status-badge rejected">Rejected</span>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminDashDrawer